<template >
  <boxDropDown title="Gerenciar Saldo Livre Com Saque">
    <template class="support-tools">

      <div class="form-group col-md-12">
        <label for="companyIdToEnableBenefits">Insira o ID da(s) empresa(s)</label>
        <input type="text" class="form-control" v-model="companyId" placeholder="ID" id="companyIdToEnableBenefits">
      </div>

      <div class="form-group col-md-12">
        <label for="toDisableWithdraw">Desabilitar Saldo Livre com Saque</label>
        <input type="checkbox" id="toDisableWithdraw" v-model="dataSend.disableWithdraw">
      </div>

      <div class="form-group col-md-12 text-center center">
        <div v-for="(item, index) in dataSend.companyId" :key="index" class="company-selected">
          <span class="company-selected__title">{{ item }}</span>
          <span class="company-selected__close" @click="removeCompany(index)">
            <ion-icon name="close-outline"/>
          </span>
        </div>
      </div>

      <div class="form-group col-md-12 text-center full-width">
        <button class="btn btn-primary" @click="addCompany()">Adicionar empresa</button>
      </div>

      <div class="send-data-tools form-group col-md-12">
        <button class="btn btn-primary" :disabled="isDisabled()" @click="sendData()">
          <span v-if="!loadingEnableBenefits">Salvar</span>
          <span v-else class="loading-btn">
            <div class="spinner-btn">
              <div class="rect1"></div>
              <div class="rect2"></div>
              <div class="rect3"></div>
              <div class="rect4"></div>
              <div class="rect5"></div>
            </div>
          </span>
        </button>
        <span class="send-data-tools__validate">{{ messageValidateFields }}</span>
      </div>
    </template>
  </boxDropDown>
</template>

<script>
  import boxDropDown from "../../../components/layouts/boxDropDown.vue";
  import {
    ENABLE_WITHDRAW
  } from "../../../../../urlConfig";
  import {
    REQUEST_SERVICE
  } from "../../../../../requestConfig";
  import {
    ALERT_SERVICE
  } from "../../../../../msgAlertService";


  export default {
    name: "enable-beneflex",
    components: {
      boxDropDown,
    },
    data() {
      return {
        messageValidateFields: "",
        companyId: "",
        dataSend: {
          disableWithdraw: false,
          companyId: []
        },
        loadingEnableBenefits: false
      }
    },
    methods: {
      isDisabled(){
        return this.loadingEnableBenefits;
      },
      addCompany() {
        if (this.companyId.trim().length !== 32) {
          this.messageValidateFields = "Id da empresa é inválido";
          return;
        }

        if(this.dataSend.companyId.includes(this.companyId)){
          this.messageValidateFields = 'A empresa já está inserida na listagem';
          return
        }

        this.dataSend.companyId.push(this.companyId);
        this.companyId = "";
        this.messageValidateFields = "";
      },
      removeCompany(index) {
        this.dataSend.companyId.splice(index, 1);
      },
      validateFields() {
        if (this.dataSend.companyId.length === 0) {
          this.messageValidateFields = "Adicione ao menos 1 empresa";
          return false;
        }

        this.messageValidateFields = "";
        return true;
      },
      sendData() {
        if (!this.validateFields()) {
          return;
        }

        this.loadingEnableBenefits = true;

        let bodyRequestJSON = {
          disableWithdraw: this.dataSend.disableWithdraw,
          companyIds: this.dataSend.companyId
        };

        REQUEST_SERVICE.requestContext('PUT', ENABLE_WITHDRAW, false, bodyRequestJSON).then((response) => {
            ALERT_SERVICE.swal("Sucesso", "Configuração feita com sucesso!", "success");
            this.clearFields();
            this.loadingEnableBenefits = false;
          }).catch((reason) => {
            this.loadingEnableBenefits = false;
            if(reason.response.data.erros.length > 0){
              ALERT_SERVICE.swal("ERRO", reason.response.data.erros[0].value, "error");
            }else{
              ALERT_SERVICE.swal("ERRO", "Entre em contato com a equipe de desenvolvimento", "error");
            }
          });
      },
      clearFields(){
        this.companyId = "";
        this.dataSend.companyId = [];
        this.messageValidateFields = "";
      }
    }
  }
</script>

<style lang="scss" scoped>
  * {
    font-family: "Montserrat", sans-serif !important;
  }

  .support-tools {
    &__warning {
      padding: 10px;
      text-align: center;
      background-color: #FFDF8D;
      border-radius: 8px !important;
      color: #FF445D;
    }
  }

  .send-data-tools {
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
    gap: 15px;

    &__validate {
      color: #ed6b75;
    }
  }

  .btn-primary {
    margin: 0 !important;
  }

  .full-width{
    width: 100% !important;
  }

  .spacing-bottom{
    margin-bottom: 8px;
  }

  .company-selected {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #F0F0F0;
    padding: 10px 10px 10px 20px;
    margin-bottom: 15px;

    &__title {
      font-weight: bold;
      color: #201E1E;
    }

    &__close {
      height: 16px;
      width: 16px;
      font-size: 16px;
      color: #E74A4E;
      cursor: pointer;
    }
  }

  .center{
    margin: auto;
  }

  .input-with-date {
    width: 100%;

    input {
      width: 100%;
    }
  }

</style>


// WEBPACK FOOTER //
// src/vue/pages/restricted/support/supportItems/enableBenefits.vue